import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        className={cn(
          "border-input focus-visible:ring-primary aria-invalid:ring-destructive/20 aria-invalid:border-destructive disabled:bg-input/50 h-10 rounded-lg border bg-white px-3 py-2 text-base transition-colors file:h-6 file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-1 aria-invalid:ring-2 md:text-sm file:text-foreground placeholder:text-muted-foreground w-full min-w-0 outline-none file:inline-flex file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

export { Input }
